import {BelgeIste} from "@/api/kisi";

export async function iste(that, tur, tashihMi) {
    const res = await BelgeIste(tur, tashihMi);

    if (res.hataVarMi && res.kod !== "yonlen") {
        that.$notify({
            group: 'ust',
            type: 'error',
            title: 'Hata',
            text: res.mesaj
        });

        if (res.kod === "giris-yap") {
            setTimeout(() => {
                this.$router.push("/giris-yap?url=" + encodeURI(res.data))
            }, 1000);
            return
        }
        return
    }

    that.$notify({
        group: 'ust',
        type: 'success',
        title: 'Kızılay',
        text: res.mesaj
    });

    setTimeout(async () => {
        try {
            await that.$router.push("belgeler?ne=sahsi&tur=" + tur);
        } catch (e) {
            window.location.reload();
        }
    }, 2000);

}